// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__10n-G","filesListContainer":"PosDisputesFiles_filesListContainer__1zJpc","filesButton":"PosDisputesFiles_filesButton__2PIYv"};